import GlobalModal from '@/utils/modal/Modal';
import { DeleteFilled } from '@ant-design/icons';
import { useState } from 'react';
import { useDeleteVersions } from './hooks/useVersions';

export const DeleteModal = ({ id, refetch }) => {
  const [open, setOpen] = useState(false);

  const { mutateAsync: deleteVersion } = useDeleteVersions();

  const handleOk = () => {
    deleteVersion(id);
    refetch();
  };
  return (
    <>
      <div
        size="medium"
        className="text-danger tw-cursor-pointer"
        onClick={() => {
          setOpen(true);
        }}
      >
        <DeleteFilled />
      </div>
      <GlobalModal
        isVisible={open}
        onConfirm={() => handleOk()}
        onClose={() => setOpen(false)}
        type="delete"
      />
    </>
  );
};
